import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';

function useInitialized(check) {
  var initializedRef = useRef(check);
  if (check) {
    initializedRef.current = true;
  }
  return !!initializedRef.current;
}
var Mask = function Mask(props) {
  var cls = classNames('admMask', props.className, {
    'admMaskHidden': !props.visible
  });
  var initialized = useInitialized(props.visible);
  function handleClick(e) {
    if (e.currentTarget === e.target) {
      var _props$onMaskClick;
      (_props$onMaskClick = props.onMaskClick) === null || _props$onMaskClick === void 0 ? void 0 : _props$onMaskClick.call(props, e);
    }
  }
  var opacity = props.opacity === 'default' ? 0.55 : props.opacity === 'dark' ? 0.75 : props.opacity;
  var node = /*#__PURE__*/React.createElement(CSSTransition, {
    "in": props.visible,
    timeout: 200,
    classNames: 'admMask',
    onExited: props.afterClose,
    unmountOnExit: props.destroyOnClose
  }, /*#__PURE__*/React.createElement("div", {
    className: cls,
    onClick: handleClick,
    style: _objectSpread2(_objectSpread2({}, props.style), {}, {
      backgroundColor: "rgba(0, 0, 0, ".concat(opacity, ")")
    })
  }, initialized && props.children));
  if (props.getContainer) {
    var container = props.getContainer;
    return /*#__PURE__*/createPortal(node, container);
  }
  return node;
};
Mask.defaultProps = {
  visible: true,
  destroyOnClose: false,
  opacity: 'default'
};

export { Mask };
